import { Suspense, lazy } from "react";
import Loader from "../../customs/loader/main";


const Main = lazy (
  () => import("../../components/reports/accreditationReport/main")
);

const AccreditationReport = () => {
  return (
    // <Layout>
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    // </Layout>
  );
};

export default AccreditationReport;
